import { footerLinks } from "@/mocks/expose";

const anchorFor = (group: string) =>
  group === "深挖频道" ? "#topics" : group === "编辑部" ? "#comments" : "#top";

export default function Footer() {
  return (
    <footer className="mt-2 border-t border-background-200/70 bg-background-100">
      <div className="mx-auto max-w-page px-4 py-12 md:px-6">
        <div className="grid gap-8 md:grid-cols-5">
          <div className="md:col-span-2">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-500 text-sm font-black text-background-50">
                呱
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">呱呱爆料</span>
            </a>
            <p className="mt-3 max-w-sm text-sm leading-6 text-foreground-600">
              从真实身份到背后金主，从隐藏关系到私下聊天——呱呱爆料只做可复核的未公开信息深挖。
              不渲染、不站队，把证据和争议一起摆在读者面前。
            </p>
            <div className="mt-4 flex flex-wrap gap-2 text-xs">
              {["真实身份", "背后金主", "隐藏关系", "私下聊天", "未公开信息"].map((k) => (
                <a
                  key={k}
                  href="#topics"
                  className="rounded-full border border-background-200 bg-background-50 px-2.5 py-1 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
                >
                  {k}
                </a>
              ))}
            </div>
          </div>

          {footerLinks.map((col) => (
            <div key={col.group}>
              <h4 className="text-sm font-semibold text-foreground-900">{col.group}</h4>
              <ul className="mt-3 space-y-2">
                {col.items.map((item) => (
                  <li key={item}>
                    <a
                      href={anchorFor(col.group)}
                      className="text-sm text-foreground-600 transition-colors hover:text-foreground-950"
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center">
          <p className="whitespace-nowrap">© 2026 呱呱爆料 · 深挖档案总第 09 期</p>
          <div className="flex flex-wrap gap-x-4 gap-y-1 sm:ml-auto">
            <a href="#top" className="hover:text-foreground-800">关于我们</a>
            <a href="#top" className="hover:text-foreground-800">报道原则</a>
            <a href="#top" className="hover:text-foreground-800">纠错与辟谣</a>
            <a href="#top" className="hover:text-foreground-800">转载规范</a>
            <a href="#cta" className="hover:text-foreground-800">提供线索</a>
          </div>
        </div>
        <p className="mt-3 text-[11px] leading-5 text-foreground-400">
          本站内容均为公开信息交叉验证的演示性报道，涉及人名与图片均为演示代号/示意素材；对无法复核的未公开信息一律不作定论。
        </p>
      </div>
    </footer>
  );
}